interface NavSection {
  el: HTMLElement;
  id: string;
  label: string;
}

export class JumpNavigation {
  private readonly navList: HTMLElement;
  private readonly sections: NavSection[];
  private observer: IntersectionObserver | null = null;

  constructor() {
    const navList = document.getElementById('jump-nav-list');
    if (!navList) return;

    this.navList = navList;
    this.sections = Array.from(
      document.querySelectorAll<HTMLElement>('section[data-nav-label]')
    ).map((el) => ({
      el,
      id: el.id,
      label: el.dataset.navLabel ?? '',
    }));

    if (this.sections.length === 0) return;

    this.buildNav();
    this.observeSections();
    this.bindLogoScrollToTop();
  }

  private buildNav(): void {
    this.sections.forEach(({ id, label }) => {
      const li = document.createElement('li');
      li.className = 'mainmenu-list-item mainmenu-list-item__lp';

      const a = document.createElement('a');
      a.className = 'jumplink hover';
      a.href = `#${id}`;
      // kein tabIndex=-1: Links müssen per Tastatur erreichbar sein
      a.addEventListener('click', (e) => this.handleClick(e, id));

      const span = document.createElement('span');
      span.textContent = label;

      a.appendChild(span);
      li.appendChild(a);
      this.navList.appendChild(li);
    });
  }

  private handleClick(e: MouseEvent, id: string): void {
    e.preventDefault();
    this.closeMobileMenu();

    const target = document.getElementById(id);
    if (!target) return;

    const headerHeight = (document.getElementById('header')?.offsetHeight ?? 0);
    const top = target.getBoundingClientRect().top + window.scrollY - headerHeight;

    window.scrollTo({ top, behavior: 'smooth' });
  }

  private closeMobileMenu(): void {
    const menuLayer = document.getElementById('mainmenu_layer');
    const menuTrigger = document.getElementById('lp_mainmenu_toggle');
    if (menuLayer?.classList.contains('mainmenu-layer__open')) {
      menuLayer.classList.remove('mainmenu-layer__open');
      menuLayer.setAttribute('aria-hidden', 'true');
      menuTrigger?.setAttribute('aria-expanded', 'false');
    }
  }

  private observeSections(): void {
    this.observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.setActive(entry.target.id);
          }
        });
      },
      {
        // Section becomes "active" when it enters the top third of the viewport
        rootMargin: '-10% 0px -60% 0px',
        threshold: 0,
      }
    );

    this.sections.forEach(({ el }) => this.observer!.observe(el));
  }

  private bindLogoScrollToTop(): void {
    document.querySelector<HTMLElement>('.header-main-logo .meta-menu-link')
      ?.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeMobileMenu();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
  }

  private setActive(id: string): void {
    this.navList
      .querySelectorAll<HTMLElement>('.mainmenu-list-item')
      .forEach((li) => {
        const isActive = li.querySelector('a')?.getAttribute('href') === `#${id}`;
        li.classList.toggle('mainmenu-list-item__active', isActive);
      });
  }
}
